import * as React from 'react';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { SessionMetadata } from '../../../cough/analyse/interfaces/state';

interface ItemMetadataProps {
    metadata: SessionMetadata;
}

export const ItemMetadata = (props : ItemMetadataProps) => {

    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    if (props.metadata) {
        return (
            <div className="panel panel-default">
                <div className="panel-body">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Study</th>
                                <th>Site Number</th>
                                <th>{fieldDisplayText.SubjectId}</th>
                                <th>Technician</th>
                                <th>Visit Name</th>
                                <th>Session Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{props.metadata.study}</td>
                                <td>{props.metadata.siteNumber}</td>
                                <td>{props.metadata.subjectNumber}</td>
                                <td>{props.metadata.technician ? props.metadata.technician : "-" }</td>
                                <td>{props.metadata.visitName}</td>
                                <td>{props.metadata.sessionName}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    } else {
        return null;
    }
}
